// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"08d18273","254":"e3a47cc4","343":"e77592a5","515":"7268eac0","607":"61b9012c","798":"5908474c"}[chunkId] + ".chunk.css";
};